export default function(user){

    if(user.initials){
        return user.initials.toUpperCase();
    }

    const lastParts = user.lastName.split(' ');
    var lastChar = '';

    if(lastParts.length > 0){
        lastChar = lastParts[lastParts.length-1].charAt(0);
    }

    return user.firstName.charAt(0) + lastChar;
}